<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Детали транзакции
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'transactions' }">← Назад к Транзакциям</router-link>
    </div>

    <transactionDetail :transaction-id="$route.params.transaction_id" />

  </div>
</template>

<script>
import transactionDetail from '@/components/details/transaction/TransactionDetail'

export default {
  name: 'transaction-details',
  components: { transactionDetail }
}
</script>


// WEBPACK FOOTER //
// TransactionDetails.vue?2452a0b7